import React, { useEffect, useState } from 'react';
import './index.scss';
import {
    Button,
    Col,
    Divider,
    Image,
    Row,
    Typography,
    notification,
    Space,
    Form,
    Input, Radio, Spin, Select, Skeleton, Switch, InputNumber, Upload, Slider,
} from 'antd';
import ReactQuill, { Quill } from 'react-quill';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import {
    UploadOutlined,
    ArrowLeftOutlined,
    DeleteFilled,
} from '@ant-design/icons';

import API_SERVICE from 'shared/services/api-service';
import { getImageUrl, UploadFile, UploadImage } from 'shared/services/Utility';
import TextArea from 'antd/es/input/TextArea';
import { fillEn } from '../../methods/forms';

interface Props {
    location: any;
    hideHeader?: boolean
    refreshItem?: any
    fetching?: boolean
    item?: any
}

const { Title, Text } = Typography;
const { Option } = Select;
export default function ContentForm(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();
    const RouteParams: any = useParams();
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);
    const [formType, setFormType] = useState('');
    const [image, setImage] = useState({ image: null, imageId: null } as any);
    const [uploading, setUploading] = useState(false);
    const [selectedLang, setSelectedLang] = useState('en' as any);
    const [uploadedVideos, setUploadedVideos] = useState('' as any);
    const [IsVidQuiz, setIsVideoQuiz] = useState(false as boolean);
    const [quizSelectedVidId, setQuizSelectedVidId] = useState('' as any);
    const [range, setRange] = useState('' as any);
    const item = props.item;
    const fetching = props.fetching;

    const renderSubForm = () => {
        if (!form.getFieldsValue()['type']) {
            return;
        }
        if (form.getFieldsValue()['type'] === 'lecture') {
            return <LectureForm form={form} t={t} saving={saving} RouteParams={RouteParams}/>;
        }
        if (form.getFieldsValue()['type'] === 'assignment') {
            return <AssignmentForm form={form} t={t} saving={saving} RouteParams={RouteParams}/>;
        }
        if (form.getFieldsValue()['type'] === 'quiz') {
            return <QuizForm form={form} t={t} saving={saving} RouteParams={RouteParams}/>;
        }
        if (form.getFieldsValue()['type'] === 'scorm') {
            return <SCORMForm form={form} t={t} saving={saving} RouteParams={RouteParams}/>;
        }
        if (form.getFieldsValue()['type'] === 'html') {
            return <HTMLForm form={form} t={t} saving={saving} RouteParams={RouteParams}/>;
        }
    };
    useEffect(() => {
        let localLang = localStorage.getItem("language")
        if(localLang != undefined && localLang != null && localLang != ''){
            setSelectedLang(localLang)
        }
        console.log('localLanguage',selectedLang)
    }, []);

    const uploadedVid = () =>{
        API_SERVICE.fetchUploadedVideo(item?.course_id,item?.curriculum_id).then((data) => {
            setUploadedVideos(data.data.data);
        }).catch((e) => {
            notification.error({ message: API_SERVICE.handleErrors(e) });
            setSaving(false);
        });
    }

    useEffect(() => {
        if(item && item.id){
            uploadedVid();
        }
    },[])

    if (fetching) {
        return <Skeleton active={true}/>;
    }
    return (
        <div className={props.hideHeader ? '' : 'list-page-wrapper'}>
            {
                !props.hideHeader && <>
                    <Row gutter={20} justify={'space-between'}>
                        <Col flex={'auto'}>
                            <Space align={'start'}>
                                <Button type={'link'} onClick={() => history.goBack()} icon={<ArrowLeftOutlined/>}/>
                                <Title
                                    level={3}>{RouteParams['mode'] === 'create' ? t('content.create') : ''}</Title>
                            </Space>
                        </Col>
                    </Row>
                    <Divider/></>
            }
            <div className="pl-sm-5 br-5 bg-white pt-3 pb-3 pr-sm-5">
                <div className="row">
                    <div className="col-md-5 mt-4">
                    <h5>{t('genDict.contentInformation')}</h5>
                        <p className="text-secondary">{t('genDict.paragraph')}</p>
                    </div>
                    <div className="col-md-7 mt-4">
                        <Form
                            size="large"
                            form={form}
                            initialValues={item}
                            fields={[]}
                            onFinishFailed={(...e) => {
                                console.log(e);
                            }}
                            onFinish={(value) => {
                                const reqObj: any = fillEn(value);
                                if(range !== '' ){
                                    reqObj['opensAt'] = range;
                                }
                                setSaving(true);
                                if (value.type === 'assignment') {
                                    value['attachments'] = [value.assignmentId];
                                }
                                if (item && item.id) {
                                    API_SERVICE.updateContent(RouteParams['courseId'], RouteParams['curriculumId'], item.id, reqObj).then((d) => {
                                        history.goBack();
                                    }).catch((e) => {
                                        notification.error({ message: API_SERVICE.handleErrors(e) });
                                        setSaving(false);
                                    });
                                } else {
                                    API_SERVICE.createContent(RouteParams['courseId'], RouteParams['curriculumId'], reqObj).then((d) => {
                                        history.goBack();
                                    }).catch((e) => {
                                        notification.error({ message: API_SERVICE.handleErrors(e) });
                                        setSaving(false);
                                    });
                                }
                            }}
                            layout="vertical"
                            requiredMark={true}
                        >

                            <Form.Item
                                label={t('title.label')}
                                name={['title', selectedLang]}
                                rules={[
                                    { required: true, message: t('title.required') },
                                ]}
                            >
                                <Input className="form-control" disabled={RouteParams['mode'] === 'view'}/>
                            </Form.Item>
                            <Form.Item
                                label={t('description.label')}
                                name={['description', selectedLang]}
                                rules={[
                                    { required: true, message: t('description.required') },
                                    { min: 20, message: t('minLength20.required') },
                                ]}
                            >
                                <Input className="form-control" disabled={RouteParams['mode'] === 'view'}/>
                            </Form.Item>
                            {/* <Form.Item
                                label={t('content.description.label')}
                                name={['description', 'en']}
                                rules={[
                                    { min: 20, message: t('content.description.minLength20') },
                                ]}>
                                <Input disabled={!RouteParams['mode']}/>
                            </Form.Item> */}
                            <Form.Item
                                label={t('content.isPreview.label')}
                                name="is_preview"
                                valuePropName={'checked'}
                                rules={[]}
                            >
                                <Switch disabled={RouteParams['mode'] === 'view'}/>
                            </Form.Item>
                            <Form.Item
                                label={t('content.sortOrder.label')}
                                name={'sort_order'}
                                initialValue={item ? item.sort_order : 0}
                                rules={[]}>
                                <InputNumber className="form-control" min={0} disabled={RouteParams['mode']==='view'}/>
                            </Form.Item>
                            {item?.isVideoQuiz === 1 && <>
                                <Form.Item
                                    label={t('Video Quiz')}
                                    name="isVideoQuiz"
                                    rules={[]}
                                >
                                    {/* <Switch disabled={!RouteParams['mode']}/> */}
                                    <Switch disabled={RouteParams['mode'] === 'view'} onChange={(e: any) => {
                                        setIsVideoQuiz(e)
                                        if(e === true){
                                            uploadedVid();
                                        }
                                    }}/>
                                </Form.Item>

                                {IsVidQuiz && <><Form.Item
                                        label={t('Select Video')}
                                        name={'forVideoId'}
                                        rules={[
                                            { required: true, message: t('Video Required') },
                                        ]}>
                                        <Select className='br-1' disabled={RouteParams['mode'] === 'view'} onChange={(e: any) => setQuizSelectedVidId(e)}>
                                            {uploadedVideos && uploadedVideos.map((uploadedVideo : any) => {
                                                return <Option value={uploadedVideo?.id}>{uploadedVideo?.title}</Option>
                                            })}
                                        </Select>
                                    </Form.Item>
                                    {quizSelectedVidId !== '' && quizSelectedVidId !== 0 && <Form.Item
                                        label={t('Pops At (In sec)')}
                                        name="opensAt"
                                        // rules={[{ required: true, message: t('Popups Time Required') },]}
                                    >
                                        {uploadedVideos && uploadedVideos.map((uploadedVideo : any) => {
                                            if(uploadedVideo?.id === quizSelectedVidId){
                                                return <Slider
                                                min={1}
                                                max={uploadedVideo?.duration_in_minutes ? (uploadedVideo?.duration_in_minutes * 60) : 1}
                                                onChange={(e: any) => setRange(e)}
                                            />
                                            }
                                        })}
                                    </Form.Item>}
                                </>}

                            </>}
                            <Form.Item
                                label={t('content.type.label')}
                                name={'type'}
                                rules={[
                                    { required: true, message: t('content.type.required') },
                                ]}>
                                <Select className="br-5" disabled={RouteParams['mode'] === 'view'} onChange={(e: any) => setFormType(e)}>
                                    <Option value={'lecture'}>{t('content.lecture.label')}</Option>
                                    <Option value={'assignment'}>{t('content.assignment')}</Option>
                                    <Option value={'scorm'}>{t('content.scorm')}</Option>
                                    <Option value={'quiz'}>{t('content.quiz')}</Option>
                                    <Option value={'html'}>{t('content.html')}</Option>
                                </Select>
                            </Form.Item>
                            {
                                renderSubForm()
                            }

                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );
}

const LectureForm = ({ t, form, item, saving, RouteParams }: any) => {
    const [uploading, setUploading] = useState(false);
    const [video, setVideo] = useState({ video: null, videoId: null } as any);
    const [lectureType, setLectureType] = useState(null as any);
    const uploadVideo = async (file: any) => {
        setUploading(true);
        setVideo({ video: null, videoId: null });
        const { file: video, fileId: videoId, error } = await UploadFile(file);
        if (error) {
            notification.error({ message: error });
        }
        setVideo({ video, videoId });
        form.setFieldsValue({ [form.getFieldsValue()['lecture_type']]: videoId });
        setUploading(false);
    };
    return <>

        <Form.Item
            label={t('content.lectureType.label')}
            name={'lecture_type'}
            initialValue={item ? item.lecture_type : 'video_id'}
            rules={[
                { required: true, message: t('content.lectureType.required') },
            ]}>
            <Select className="br-5" disabled={RouteParams['mode'] === 'view'} onChange={(e) => {
                setLectureType(e);
                form.setFieldsValue({
                    'video_id': null,
                    'external_url': null,
                    'vimeo_url': null,
                    'youtube_url': null,
                });
            }
            }>
                {
                    ['video_id', 'external_url', 'vimeo_url', 'youtube_url'].map((p) => {
                        return <Option value={p}>{t('content.lecture.' + p)}</Option>;
                    })
                }
            </Select>
        </Form.Item>
        {
            (['external_url', 'youtube_url', 'vimeo_url'].indexOf(form.getFieldsValue()['lecture_type']) > -1) ?
                <Form.Item
                    label={t('content.' + form.getFieldsValue()['lecture_type'])}
                    name={form.getFieldsValue()['lecture_type']}
                    rules={[
                        { required: true, message: t('content.lectureType.required') },
                    ]}>
                    <Input className="form-control"  disabled={RouteParams['mode'] === 'view'}/>
                </Form.Item> :
                uploading ? <Spin/> : (
                    video.video ? <div>
                        <Space size={20} direction={'horizontal'}>
                            {/*@ts-ignore*/}
                            <Form.Item
                                label={t('content.' + form.getFieldsValue()['lecture_type'])}
                                name={form.getFieldsValue()['lecture_type']}
                                className={'hide-input'}
                                rules={[
                                    { required: true, message: t('content.lectureType.required') },
                                ]}>
                                <Text style={{ paddingLeft: '10px' }}>{video.video.name}</Text>
                                <Input disabled={true}/>
                            </Form.Item>
                            {
                                RouteParams['mode'] &&
                                <Button danger size={'middle'} shape={'circle'} type={'primary'}
                                        onClick={() => {
                                            form.setFieldsValue({ [form.getFieldsValue()['lecture_type']]: null });
                                            setVideo({
                                                video: null,
                                                videoId: null,
                                            });
                                        }}><DeleteFilled/></Button>
                            }
                        </Space>
                    </div> : <Upload beforeUpload={(file) => {
                        if (!(file.type === 'video/mp4')) {
                            notification.error({ message: `MP4 ${t('genDict.required')}` });
                        }
                        uploadVideo(file);
                        return false;
                    }}>
                        <Button icon={<UploadOutlined/>}>{t('genDict.uploadVideo')}</Button>
                    </Upload>
                )
        }

        <br/>
        {
            <Form.Item>
                <Button
                    htmlType="submit"
                    loading={saving || uploading}
                    disabled={uploading}
                    shape="round"
                    size={'large'}
                    className="submit btn-blue"
                >
                    {t('genDict.save')}
                </Button>
            </Form.Item>
        }
    </>;
};


const AssignmentForm = ({ t, form, item, saving, RouteParams }: any) => {
    const [uploading, setUploading] = useState(false);
    const [assignment, setAssignment] = useState({ assignment: null, assignmentId: null } as any);
    const uploadFile = async (file: any) => {
        setUploading(true);
        setAssignment({ assignment: null, assignmentId: null });
        const { file: assignment, fileId: assignmentId, error } = await UploadFile(file);
        if (error) {
            notification.error({ message: error });
        }
        setAssignment({ assignment, assignmentId });
        form.setFieldsValue({ assignmentId });
        setUploading(false);
    };
    return <>

        {(assignment.assignment ? <div>
            
                <Space size={20} direction={'horizontal'}>
                    {/*@ts-ignore*/}
                    <Form.Item
                        label={t('content.assignment')}
                        name={'assignmentId'}
                        className={'hide-input'}
                        rules={[
                            { required: true, message: t('content.assignment.required') },
                        ]}>
                        <Text style={{ paddingLeft: '10px' }}>{assignment.assignment.name}</Text>
                        <Input disabled={true}/>
                    </Form.Item>
                    {
                        RouteParams['mode'] &&
                        <Button danger size={'middle'} shape={'circle'} type={'primary'}
                                onClick={() => {
                                    form.setFieldsValue({ 'assignment': null });
                                    setAssignment({
                                        assignment: null,
                                        assignmentId: null,
                                    });
                                }}><DeleteFilled/></Button>
                    }
                </Space>
            </div> : <Upload beforeUpload={(file) => {
                if (!(file.type === 'application/pdf')) {
                    notification.error({ message: `PDF ${t('genDict.required')}` });
                }
                uploadFile(file);
                return false;
            }}>
                <Button icon={<UploadOutlined/>}>{t('genDict.uploadPDF')}</Button>
            </Upload>
        )}

        <br/>
        {
            <Form.Item>
                <Button
                    htmlType="submit"
                    loading={saving}
                    disabled={uploading}
                    shape="round"
                    size={'large'}
                    className="submit btn-blue"
                >
                    {t('genDict.save')}
                </Button>
            </Form.Item>
        }
    </>;
};


const SCORMForm = ({ t, form, item, saving, RouteParams }: any) => {
    const [uploading, setUploading] = useState(false);
    const [scorm, setScorm] = useState({ scorm: null, scormId: null } as any);
    const history = useHistory();
    const uploadFile = async () => {
        setUploading(true);
        const data = new FormData();
        data.append('file', form.getFieldsValue()['scorm']);
        data.append('title[en]', form.getFieldsValue()['title']['en']);
        data.append('title[de]', form.getFieldsValue()['title']['de']);
        data.append('curriculum_id', RouteParams['curriculumId']);
        data.append('course_id', RouteParams['courseId']);
        try {
            const response = await API_SERVICE.scormUpload(data);
            console.log(response);
            history.goBack();
        } catch (e) {
            notification.error({ message: API_SERVICE.handleErrors(e) });
        }
        setUploading(false);
    };
    return <>

        {(scorm.scorm ? <div>
                <Space size={20} direction={'horizontal'}>
                    {/*@ts-ignore*/}
                    <Form.Item
                        label={t('content.scorm.label')}
                        name={'scorm'}
                        className={'hide-input'}
                        rules={[
                            { required: true, message: t('content.scorm.required') },
                        ]}>
                        <Text style={{ paddingLeft: '10px' }}>{scorm.scorm.name}</Text>
                        <Input disabled={true}/>
                    </Form.Item>
                    {
                        RouteParams['mode'] &&
                        <Button danger size={'middle'} shape={'circle'} type={'primary'}
                                onClick={() => {
                                    form.setFieldsValue({ 'scorm': null });
                                    setScorm({
                                        scorm: null,
                                        scormId: null,
                                    });
                                }}><DeleteFilled/></Button>
                    }
                </Space>
            </div> : <Upload beforeUpload={(file) => {
                setScorm({ scorm: file });
                form.setFieldsValue({ 'scorm': file });
                return false;
            }}>
                <Button icon={<UploadOutlined/>}>{t('genDict.uploadSCORM')}</Button>
            </Upload>
        )}

        <br/>
        {
            <Form.Item>
                <Button
                    loading={saving}
                    disabled={uploading}
                    shape="round"
                    size={'large'}
                    onClick={() => uploadFile()}
                    className="submit btn-blue"
                >
                    {t('genDict.save')}
                </Button>
            </Form.Item>
        }
    </>;
};

const HTMLForm = ({ t, form, item, saving, RouteParams }: any) => {
    const [uploading, setUploading] = useState(false);
    const [html, setHTML] = useState(null as any);
    const history = useHistory();
    const uploadFile = async () => {
        setUploading(true);
        const data = new FormData();
        data.append('file', form.getFieldsValue()['scorm']);
        data.append('title[en]', form.getFieldsValue()['title']['en']);
        data.append('title[de]', form.getFieldsValue()['title']['de']);
        try {
            const response = await API_SERVICE.htmlUpload(RouteParams['courseId'], RouteParams['curriculumId'], data);
            console.log(response);
            history.goBack();
        } catch (e) {
            notification.error({ message: API_SERVICE.handleErrors(e) });
        }
        setUploading(false);
    };
    return <>

        {(html ? <div>
                <Space size={20} direction={'horizontal'}>
                    {/*@ts-ignore*/}
                    <Form.Item
                        label={t('content.html.label')}
                        name={'scorm'}
                        className={'hide-input'}
                        rules={[
                            { required: true, message: t('content.html.required') },
                        ]}>
                        <Text style={{ paddingLeft: '10px' }}>{html.name}</Text>
                        <Input disabled={true}/>
                    </Form.Item>
                    {
                        RouteParams['mode'] &&
                        <Button danger size={'middle'} shape={'circle'} type={'primary'}
                                onClick={() => {
                                    form.setFieldsValue({ 'scorm': null });
                                    setHTML(null);
                                }}><DeleteFilled/></Button>
                    }
                </Space>
            </div> : <Upload beforeUpload={(file) => {
                setHTML(file);
                form.setFieldsValue({ 'scorm': file });
                return false;
            }}>
                <Button icon={<UploadOutlined/>}>{t('genDict.uploadHTML')}</Button>
            </Upload>
        )}

        <br/>
        {
            <Form.Item>
                <Button
                    loading={saving}
                    disabled={uploading}
                    shape="round"
                    size={'large'}
                    onClick={() => uploadFile()}
                    className="submit btn-blue"
                >
                    {t('genDict.save')}
                </Button>
            </Form.Item>
        }
    </>;
};


const QuizForm = ({ t, form, item, saving, RouteParams }: any) => {
    return <>

        <Form.Item
            label={t('content.generalInstructions.label')}
            name={'general_instructions'}
            rules={[
                { required: true, message: t('content.generalInstructions.required') },
                { min: 20, message: t('content.generalInstructions.minLength20') },
            ]}>
            <TextArea rows={4}/>
        </Form.Item>
        <br/>
        {
            <Form.Item>
                <Button
                    htmlType="submit"
                    loading={saving}
                    shape="round"
                    size={'large'}
                    className="submit btn-blue"
                >
                    {t('genDict.save')}
                </Button>
            </Form.Item>
        }
    </>;
};
